import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import PropTypes from 'prop-types'

import appActions from '../../redux/app/actions'
import { TopbarWrapper } from './topbar.style'
import WebTopbar from './webTopBar'
import { useAppConfig } from '../../request/query/app'

const { toggleCollapsed } = appActions

class Topbar extends Component {
  state = {
    width: '',
    active: 0
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  render() {
    const { history, userPermissions, providerDetails } = this.props

    return (
      <TopbarWrapper>
        <Layout>
          <WebTopbar
            history={history}
            userPermissions={userPermissions}
            providerDetails={providerDetails}
          />
        </Layout>
      </TopbarWrapper>
    )
  }
}

Topbar.propTypes = {
  config: PropTypes.array.isRequired,
  userDetails: PropTypes.object.isRequired,
  permissions: PropTypes.array.isRequired
}

Topbar.defaultProps = {
  config: [],
  userDetails: {},
  permissions: []
}

export default function WrappedTopbar(props) {
  const { userPermissions, providerDetails } = useAppConfig()
  return (
    <TopbarWrapped
      userPermissions={userPermissions}
      providerDetails={providerDetails}
      {...props}
    />
  )
}

const TopbarWrapped = connect(null, { toggleCollapsed })(Topbar)
